import { render } from "./CriteriaCard005.vue?vue&type=template&id=5c884770&scoped=true"
import script from "./CriteriaCard005.vue?vue&type=script&lang=js"
export * from "./CriteriaCard005.vue?vue&type=script&lang=js"

import "./CriteriaCard005.vue?vue&type=style&index=0&id=5c884770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c884770"]])

export default __exports__